let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7po8a")).then(() => parcelRequire('lIYnd'));